import BackspaceOutlinedIcon from '@mui/icons-material/BackspaceOutlined';
import { KioskNumpadBackspaceButton, KioskNumpadButton, KioskNumpadGrid, KioskNumpadLastRow } from '../styles';

interface KioskNumpadProps {
  /** 10 shuffled digits '0'-'9'; the first 9 fill the 3x3 grid, the 10th sits centered below. */
  order: string[];
  onDigit: (digit: string) => void;
  onBackspace: () => void;
  disabled?: boolean;
}

const KioskNumpad = ({ order, onDigit, onBackspace, disabled }: KioskNumpadProps) => (
  <>
    <KioskNumpadGrid>
      {order.slice(0, 9).map(digit => (
        <KioskNumpadButton key={digit} aria-label={digit} disabled={disabled} onClick={() => onDigit(digit)}>
          {digit}
        </KioskNumpadButton>
      ))}
    </KioskNumpadGrid>
    <KioskNumpadLastRow>
      <span />
      <KioskNumpadButton aria-label={order[9]} disabled={disabled} onClick={() => onDigit(order[9])}>
        {order[9]}
      </KioskNumpadButton>
      <KioskNumpadBackspaceButton aria-label="backspace" disabled={disabled} onClick={onBackspace}>
        <BackspaceOutlinedIcon />
      </KioskNumpadBackspaceButton>
    </KioskNumpadLastRow>
  </>
);

KioskNumpad.defaultProps = {
  disabled: false,
};

export default KioskNumpad;
